import {
	VIEW_PAGE,
	HOME,
	SPACE_OVERVIEW,
	EDIT_PAGE_EMBED,
	EDIT_PAGE_V2,
	EDIT_BLOG_V2,
	EDIT_PAGE,
	EDIT_BLOG,
	VIEW_BLOG,
	VIEW_BLOG_DATE_LEGACY,
	VIEW_BLOG_MOBILE,
	DATABASE_VIEW,
	WHITEBOARD_BOARD,
	SLIDES_VIEW,
} from './routes.ts';

export const isViewPage = () => Boolean(VIEW_PAGE.match(window.location.pathname));
export const isBlogPage = () =>
	Boolean(
		VIEW_BLOG.match(window.location.pathname) ||
		VIEW_BLOG_DATE_LEGACY.match(window.location.pathname) ||
		VIEW_BLOG_MOBILE.match(window.location.pathname),
	);
export const isHomePage = () => Boolean(HOME.match(window.location.pathname));

export const isSpaceOverview = () => Boolean(SPACE_OVERVIEW.match(window.location.pathname));

/**
 * Checks if the current route is a database view.
 * @param routeName - Optional route name from RoutesContext. When routeName is provided,
 *                    uses this instead of window.location.pathname to avoid race conditions during SPA transitions.
 */
export const isDatabase = (routeName?: string | null) => {
	if (routeName !== undefined && routeName !== null) {
		return routeName === DATABASE_VIEW.name;
	}
	return Boolean(DATABASE_VIEW.match(window.location.pathname));
};

/**
 * Checks if the current route is a whiteboard view.
 * @param routeName - Optional route name from RoutesContext. When routeName is provided,
 *                    uses this instead of window.location.pathname to avoid race conditions during SPA transitions.
 */
export const isWhiteboard = (routeName?: string | null) => {
	if (routeName !== undefined && routeName !== null) {
		return routeName === WHITEBOARD_BOARD.name;
	}
	return Boolean(WHITEBOARD_BOARD.match(window.location.pathname));
};

export const isSlides = (routeName?: string | null) => {
	if (routeName !== undefined && routeName !== null) {
		return routeName === SLIDES_VIEW.name;
	}
	return Boolean(SLIDES_VIEW.match(window.location.pathname));
};

export const isEditPage = (routeName: string) => {
	if (!routeName) return false;

	const editRoutes = [
		EDIT_PAGE_EMBED.name,
		EDIT_PAGE_V2.name,
		EDIT_BLOG_V2.name,
		EDIT_PAGE.name,
		EDIT_BLOG.name,
	];

	return editRoutes.includes(routeName);
};
